import React from 'react';
import { Link } from 'react-router-dom';
import { FaHardHat, FaBuilding, FaTools, FaChartLine, FaUserTie } from 'react-icons/fa';
// import ThreeScene from '../components/ThreeScene';
import './Home.css';  
import hero from '../assets/hero.jpg';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Building Dreams, Constructing Future</h1>
          <p>Your trusted partner in construction excellence since 1983</p>
          <div className="hero-buttons">
            <Link to="/contact" className="btn btn-primary">Get a Free Quote</Link>
            <Link to="/services" className="btn btn-secondary">Explore Services</Link>
          </div>
        </div>
      </section>
      
      {/* About Section */}
      <section className="section about-section">
        <div className="container">
          <div className="about-grid">
            <div className="about-content">
              <h2 className="section-title left-align">About Preferbuild</h2>
              <p className="about-description">
                Preferrobuild Construction Company is a leading ferrocement construction firm with over 40 years of experience in delivering exceptional architectural residential and commercial projects. We take pride in our attention to detail, quality craftsmanship, and commitment to client satisfaction.
              </p>
              <p className="about-description">
                Our team of skilled professionals brings expertise and innovation to every project, ensuring that we not only meet but exceed client expectations.
              </p>
              <Link to="/about" className="btn">Learn More About Us</Link>
            </div>
            <div className="about-image-container">
              {/* <ThreeScene /> */}
              <img src={hero} alt="About Preferbuild"  />
            </div>
          </div>
        </div>
      </section>
      
      {/* Services Section */}
      <section className="section services-section">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <FaBuilding />
              </div>
              <h3>Ferrocement Construction</h3>
              <p>Customised architectural designs for homes with creative and technical planning of the elevations and other structures focusing on their aesthetic appeal, functionality and user experience.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <FaHardHat />
              </div>
              <h3>Residential & Commercial</h3>
              <p>Physical realisation of the architectural designs by skilled professionals who build the structure according to the detail blueprints ensuring the final building is both beautiful and functional.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <FaTools />
              </div>
              <h3>Renovation & Remodeling</h3>
              <p>Transform your existing spaces with our expert renovation and remodeling services.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <FaChartLine />
              </div>
              <h3>Project Management</h3>
              <p>Comprehensive project management ensuring on-time and within-budget completion.</p>
            </div>
          </div>
          <div className="services-cta">
            <Link to="/services" className="btn">View All Services</Link>
          </div>
        </div>
      </section>
      
      {/* Why Choose Us */}
      <section className="section why-us-section">
        <div className="container">
          <h2 className="section-title">Why Choose Preferbuild?</h2>
          <div className="why-us-grid">
            <div className="why-us-card">
              <div className="why-us-number">01</div>
              <h3>Quality Craftsmanship</h3>
              <p>We employ skilled professionals who take pride in their work and deliver exceptional quality in every project.</p>
            </div>
            
            <div className="why-us-card">
              <div className="why-us-number">02</div>
              <h3>Timely Delivery</h3>
              <p>We understand the importance of deadlines and strive to complete all projects on schedule.</p>
            </div>
            
            <div className="why-us-card">
              <div className="why-us-number">03</div>
              <h3>Cost Effectiveness</h3>
              <p>Our efficient processes and strategic planning ensure optimal resource utilization and cost savings.</p>
            </div>
            
            <div className="why-us-card">
              <div className="why-us-number">04</div>
              <h3>Customer Satisfaction</h3>
              <p>Your vision and satisfaction are our top priorities throughout the construction process.</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Construction Project?</h2>
            <p>Contact us today for a consultation and free quote. Let's bring your vision to life!</p>
            <Link to="/contact" className="btn btn-large">Get in Touch</Link>
          </div>
        </div>
      </section>
      
      {/* Testimonials Section */}
      <section className="section testimonials-section">
        <div className="container">
          <h2 className="section-title">What Our Clients Say</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"Preferbuild transformed our outdated office space into a modern, functional workspace. Their attention to detail and professionalism were impressive throughout the project."</p>
              </div>
              <div className="testimonial-author">
                <div className="testimonial-author-image">
                  <FaUserTie />
                </div>
                <div className="testimonial-author-info">
                  <h4>Rakesh kumar</h4>
                  <p>Business Owner</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"Working with Preferbuild on our custom home was a wonderful experience. They listened to our needs and delivered beyond our expectations. We couldn't be happier with our new home!"</p>
              </div>
              <div className="testimonial-author">
                <div className="testimonial-author-image">
                  <FaUserTie />
                </div>
                <div className="testimonial-author-info">
                  <h4>Sourabh Singh</h4>
                  <p>Architect</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"The team at Preferbuild demonstrated exceptional professionalism and expertise in handling our commercial building project. They delivered on time and within budget."</p>
              </div>
              <div className="testimonial-author">
                <div className="testimonial-author-image">
                  <FaUserTie />
                </div>
                <div className="testimonial-author-info">
                  <h4>Mitali Jain</h4>
                  <p>Interior Designer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
